import React, { FC, memo, useMemo } from 'react';
import { Text, View } from '@react-pdf/renderer';

import { BASE_FONT_SIZE } from '../pdfStyles';
import { getDateByFormat } from '../../../utils/dateUtils';

type Props = {
    companyVatNumber?: string;
    iata?: string;
    issueDate?: Date | string;
    dueDate?: Date | string | null;
    travelFileNumber?: string;
    travelFileOpenDate?: Date | string;
    travelFileStartDate?: Date | string;
    usesValueDate?: boolean;
    travelFileFirst?: boolean;
    supplierInvoiceNumber?: string;
    issuedBy?: string;
    iataLast?: boolean;
};

const PdfHeaderDetails: FC<Props> = (props: Props) => {
    const { companyVatNumber, iata, issueDate, dueDate, travelFileNumber, travelFileOpenDate, travelFileStartDate, usesValueDate, travelFileFirst, supplierInvoiceNumber, issuedBy, iataLast } = props;

    const linesData = useMemo(() => {
        const lines: Array<{ label: string; value: string }> = [];

        const formattedVat = companyVatNumber
            ? companyVatNumber.replace(/^(\d{2})(\d+)$/, '$1-$2')
            : companyVatNumber;

        if (!iataLast && iata) {
            lines.push({ label: 'IATA No', value: iata });
        }
        if (companyVatNumber) {
            lines.push({ label: 'Company VAT No', value: formattedVat || '' });
        }
        if (supplierInvoiceNumber) {
            lines.push({ label: 'Supplier Invoice', value: supplierInvoiceNumber });
        }
        if (issuedBy) {
            lines.push({ label: 'Issued by', value: issuedBy });
        }
        if (travelFileFirst && travelFileNumber) {
            lines.push({ label: 'Travel File No', value: travelFileNumber });
        }
        if (issueDate) {
            lines.push({ label: 'Issue Date', value: getDateByFormat(issueDate, 'dd-MMM-yy', 'No Date') });
        }
        if (dueDate) {
            const dateLabel = usesValueDate ? 'Value date' : 'Due Date';
            lines.push({ label: dateLabel, value: getDateByFormat(dueDate, 'dd-MMM-yy', 'No Due Date') });
        }
        if (!travelFileFirst && travelFileNumber) {
            lines.push({ label: 'Travel File No', value: travelFileNumber });
        }
        if (travelFileOpenDate) {
            lines.push({ label: 'TF Open Date', value: getDateByFormat(travelFileOpenDate, 'dd-MMM-yy', 'No Open Date') });
        }
        if (travelFileStartDate) {
            lines.push({ label: 'TF Start Date', value: getDateByFormat(travelFileStartDate, 'dd-MMM-yy', 'No Start Date') });
        }
        if (iataLast && iata) {
            lines.push({ label: 'IATA No', value: iata });
        }
        return lines;
    }, [companyVatNumber, iata, issueDate, dueDate, travelFileNumber, travelFileOpenDate, travelFileStartDate, usesValueDate, travelFileFirst, supplierInvoiceNumber, issuedBy, iataLast]);

    return (
        <View>
            {linesData.map((item, idx) => (
                <View key={idx} style={{ flexDirection: 'row', justifyContent: 'flex-end', paddingVertical: 1 }}>
                    <Text style={{ fontSize: BASE_FONT_SIZE, color: '#777', marginRight: 8 }}>{item.label}:</Text>
                    <Text style={{ fontSize: BASE_FONT_SIZE, fontWeight: 'bold', minWidth: 70, textAlign: 'right' }}>{item.value}</Text>
                </View>
            ))}
        </View>
    );
};

export default memo(PdfHeaderDetails);
